<div class="footer">
  <div class="footer-top">
    <h4>
      <!-- <button mat-button [routerLink]="''" class="example-icon" aria-label="Example icon-button with menu icon">
      </button> -->
      AfriAutos
    </h4>
    <mat-icon [style.color]="'#000000'">facebook</mat-icon>
    <div> LinkedIn</div>
    <div>Instagram</div>
  </div>

  <div class="footer-sections">
    <div class="footer-section">  
        <h4>Acheter</h4>
        <h6><a routerLink ="buy/search">Trouver un véhicule</a></h6>
        <h6><a routerLink ="customer/buy-ongoing">Mes achats en cours</a></h6>
        <h6><a routerLink ="customer/buy-favorites">Mes favoris</a></h6>
        <h6><a routerLink ="customer/buy-alerts">Mes alertes</a></h6>
        <h6><a routerLink ="customer/post-new-car">Vendre mon véhicule</a></h6>
    </div>

    <div class="footer-section">  
      <h4>Louer</h4>
      <h6><a routerLink ="rent/search">Trouver une location</a></h6>
      <h6><a routerLink ="customer/rent-ongoing">Mes locations en cours</a></h6>
      <h6><a routerLink ="customer/rent-favorites">Mes favoris</a></h6>
      <h6><a routerLink ="customer/rent-alerts">Mes alertes</a></h6>
      <h6><a routerLink ="customer/post-new-car">Louer mon véhicule</a></h6>
    </div>

    <div class="footer-section">  
      <h4>Entretenir</h4>
      <h6><a routerLink ="dealer/search">Trouver un garage</a></h6>
      <h6><a routerLink ="customer/servicing-favorites">Mes garages favoris</a></h6>
      <h6><a routerLink ="customer/park">Mon parc</a></h6>
      <!-- <h6><a routerLink ="keep/warranty">Garantie</a></h6> -->
      <h6><a routerLink ="keep/control">Controle technique</a></h6>
      <h6><a routerLink ="keep/routine">Entretiens de routine</a></h6>
    </div>

    <div class="footer-section">
      <h4>Mon compte</h4>
      <h6><a routerLink ="customer/dashboard">Tableau de bord client</a></h6>
      <h6><a routerLink ="provider/dashboard">Tableau de bord vendeur</a></h6>
      <h6><a routerLink ="customer">Mon compte Client</a></h6>
      <h6><a routerLink ="provider">Mon compte Vendeur</a></h6>
      
      <!-- <h6><a routerLink ="customer">Client</a></h6>
      <h6><a routerLink ="provider">Provider</a></h6>
      <h6><a routerLink ="owner">Propriétaire</a></h6>
      <h6><a routerLink ="admin">Admin</a></h6> -->
      <!-- 
      
      <h6><a routerLink ="account/become-partner">Devenir partenaire</a></h6>
      <h6><a routerLink ="customer/account">Mon compte</a></h6>
      <h6><a routerLink ="owner/park">Voir Mon Parc</a> </h6>
      <h6><a routerLink ="provider/public">Mon profil public</a> </h6>
      <h6><a routerLink ="owner/post-new-car">Poster nouveau véhicule</a></h6> -->

    </div>

    <div class="footer-section">
      <h4>Connection</h4>
      <h6><a routerLink ="customer/account">Me connecter</a></h6>
      <h6><a routerLink ="customer/account">M'inscrire</a> </h6>
      <h6><a routerLink ="customer/account">Recouvrir mon mot de passe</a> </h6>
      <h6><a routerLink ="admin">Admin</a></h6>
    </div>

    <div class="footer-section">
      <h4>Support</h4>
      
      <!-- <div>Certification AfriAutos</div> -->
      <h6><a routerLink ="about">A propos</a></h6>
      <h6><a routerLink ="about/contact">Contact</a></h6>
      <h6><a routerLink ="support">Support</a></h6>
      <!-- <div>Blog</div> -->
      <h6><a routerLink ="admin">Admin</a></h6>
    </div>
  </div>
</div>

<mat-divider></mat-divider>

<div class="footer-notes">
  <div class="logo">
    <img  mat-card-image src="assets/images/afriautos_logo.png" alt="CM">
  </div>

  <!--<div><h6>© Copyright 2023 AfriAutos Ltd. </h6></div>  -->
  <div class="legal-notes">
    <h6>
      <a routerLink ="provider/park">Terms & conditions</a> &nbsp;
      <a routerLink ="provider/park">Cookies</a> &nbsp;
      <a routerLink ="provider/park">Privacy policy</a>
    </h6>
  </div>
</div>




<!-- <mat-grid-list [cols]="gridCols" rowHeight="220px" (window:resize)="onResize($event)" >
    <div >
        
          <mat-list>
            <div><button mat-icon-button [routerLink]="''" class="example-icon" aria-label="Example icon-button with menu icon">
            
              AfriAutos
            </button>
          </div>
            <mat-divider></mat-divider>
            <div> <mat-icon>facebook</mat-icon>Facebook</div>
            <mat-divider></mat-divider>
            <div> <mat-icon>instagram</mat-icon>LinkedIn</div>
            <mat-divider></mat-divider>
            <div><mat-icon>instagram     </mat-icon>Inst a   gram</div>
          </mat-list>


    </div>
    <div >
        <mat-list>
            <div><h2>Acheter</h2></div> 
            <mat-divider></mat-divider>
            <div><a routerLink ="buy-car">Rechercher une Voiture</a></div>
            <mat-divider></mat-divider>
            <div><a routerLink ="buy-car/alerts">Creer une alerte</a></div>
            <mat-divider></mat-divider>
            <div>Deals de la semaine</div>
          </mat-list>

    </div>
    <div >
        <mat-list>
            <div><h2>Vendre</h2></div>
            <mat-divider></mat-divider>
            <div><a routerLink ="account/my-park">Poster ma Voiture</a></div>
            <mat-divider></mat-divider>
            <div><a routerLink ="account/my-park">Voir Mon Parc</a> </div>
            <mat-divider></mat-divider>
            <div>Certification AfriqAuto</div>
          </mat-list>

    </div>
    <div >
        <mat-list>
            <div><h2>Support</h2></div>
            <mat-divider></mat-divider>
            <div>Blog</div>
            <mat-divider></mat-divider>
            <div>Nous contacter</div>
            <mat-divider></mat-divider>
            <div> .</div>
          </mat-list>
    </div>
</mat-grid-list>
   -->

